// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1353":"8e7d0fdc","3938":"ba13f972","4181":"a8e8b83b","4279":"a8e8b83b","8504":"a8e8b83b"}[chunkId] + ".chunk.css";
};